export const toEntityDict = <T, R = T>(
    ary: T[],
    key = 'id',
    field: string | null = null
): Record<string, R> => {
    return ary.reduce((dict: Record<string, R>, t: T) => {
        const item = (t as any);
        const dictKey = item[key];
        const dictValue = !!field ? item[field] : structuredClone(item);
        dict[dictKey] = dictValue;
        return dict;
    }, {});
};

export const toEntityDictGroupByKey = <T>(
    ary: T[],
    key: keyof T
): Record<string, T[]> => {
    return ary.reduce((dict, item) => {
        const dictKey = String(item[key]);
        const dictValue = structuredClone(item)
        if (!dict[dictKey]) dict[dictKey] = [];
        dict[dictKey].push(dictValue);
        return dict;
    }, {} as Record<string, T[]>);
};